import { defineComponent as _defineComponent } from 'vue'

  import { Document } from "@/types/CustomerLotDetails";
  import { formatDateMonthDayYear } from "@/helpers/date";
  import DocumentItemWithSlot from "@/components/ui/DocumentItemWithSlot.vue";
  import { getDocumentName } from "@/helpers/documents";

  interface Props {
    documents: Document[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLotDocuments',
  props: {
    documents: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get Document() { return Document }, get formatDateMonthDayYear() { return formatDateMonthDayYear }, DocumentItemWithSlot, get getDocumentName() { return getDocumentName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})